<template>
  <transition name="el-fade-in-linear">
    <div v-show="dialogVisible" class="popContainer indiv-pop">
      <div class="indiv-pop-center">
        <span
          class="indiv-pop-close iconfont icon-close_round_fill_bold"
          role="button"
          aria-label="关闭"
          @click="onClose"
        ></span>
        <div class="indiv-pop-box agreement-pop">
          <h3 class="hd">试用协议</h3>
          <div class="body">
            <div class="agreement-content indiv-scrollbar">
              <p>
                <b>【首部及导言】</b><br /><br />
                欢迎您申请使用杰宜斯云账户相关功能的试用服务！<br /><br />
                &emsp;&emsp;
                <b>
                  为申请并使用杰宜斯云提供的账户试用服务，您应当阅读并遵守本《试用协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是关于试用范围、试用结束后的处理方式，以及免除或者限制杰宜斯云责任的条款。<br /><br />
                  &emsp;&emsp;除非您已充分阅读、完全理解并接受本协议所有条款，否则您无权申请或使用试用服务。您勾选同意本协议、点击“同意”或实际申请开通试用，均视为您已阅读并同意签署本协议。<br /><br />
                  &emsp;&emsp;本协议是《杰宜斯云服务协议》的补充协议。试用期间，您同时应当遵守《杰宜斯云服务协议》及《杰宜斯云隐私政策》的相关规定。
                </b>
                <br /><br />
                &emsp;&emsp;<span class="agreement-warn">
                  <b>如果您不同意本协议中的任何条款，您应立即停止申请或使用试用服务。</b>
                </span>
                <br /><br />

                <b>一、【试用服务说明】</b><br /><br />
                &emsp;&emsp;1.1
                试用服务是指杰宜斯云向符合条件的用户提供的、免费体验指定账户功能的服务，具体以杰宜斯云实际提供的功能为准。<br /><br />
                &emsp;&emsp;1.2
                试用服务包括但不限于 CTP 直连账户、第三方账户等相关功能，具体适用范围以页面展示及系统配置为准。<br /><br />
                &emsp;&emsp;1.3
                试用服务仅供您个人或您所代表的主体在试用期间进行功能体验，不得用于商业转售、非法用途或任何损害杰宜斯云及第三方合法权益的行为。<br /><br />
                &emsp;&emsp;1.4
                您知悉并同意，当前为您提供的系试用版本，其功能、性能、稳定性可能与正式版本存在差异，亦可能存在尚未发现的缺陷或不足。试用期间如出现任何问题、故障、数据异常或由此导致的损失，您应自行承担相应风险。<br /><br />

                <b>二、【试用规则】</b><br /><br />
                &emsp;&emsp;2.1
                试用时长以杰宜斯云页面展示、系统配置或另行通知为准。<br /><br />
                &emsp;&emsp;2.2
                试用结束后，如您未购买相应服务，杰宜斯云有权终止向您提供相关功能，您将无法继续正常使用试用范围内的服务。<br /><br />
                &emsp;&emsp;2.3
                杰宜斯云有权根据业务需要调整试用规则、试用次数或试用资格，调整后将通过页面提示、公告或其他合理方式通知您。<br /><br />

                <b>三、【用户义务】</b><br /><br />
                &emsp;&emsp;3.1
                您应保证申请试用时提交的信息真实、准确、完整，并对试用期间的操作行为负责。<br /><br />
                &emsp;&emsp;3.2
                试用期间，您应妥善保管账号及密码，不得将试用资格转让、出借或提供给他人使用。<br /><br />
                &emsp;&emsp;3.3
                您不得利用试用服务从事任何违反法律法规、监管要求或平台规则的行为。<br /><br />

                <b>四、【服务变更与终止】</b><br /><br />
                &emsp;&emsp;4.1
                杰宜斯云有权根据运营需要对试用服务的功能、范围、规则进行调整，并尽可能提前告知。<br /><br />
                &emsp;&emsp;4.2
                如您违反本协议、服务协议或相关法律法规，杰宜斯云有权立即终止您的试用资格，且不承担任何责任。<br /><br />
                &emsp;&emsp;4.3
                试用服务按“现状”提供，杰宜斯云不对试用期间的持续性、稳定性或特定结果作出保证。<br /><br />

                <b>五、【其他】</b><br /><br />
                &emsp;&emsp;5.1
                本协议未尽事宜，适用《杰宜斯云服务协议》《杰宜斯云隐私政策》及相关规则。<br /><br />
                &emsp;&emsp;5.2
                杰宜斯云有权根据需要修订本协议，修订后的协议公布后即生效；若您继续使用试用服务，即视为接受修订后的协议。<br /><br />
                &emsp;&emsp;5.3
                如您对本协议有任何疑问，可通过平台提供的客服渠道与我们联系。（正文完）<br /><br /><br /><br />
              </p>
            </div>
            <div class="agreement-check">
              <el-checkbox v-model="agreed" style="color:#525252">已阅读并同意《试用协议》</el-checkbox>
            </div>
          </div>
          <div class="foot">
            <el-button
              class="indiv-btn"
              type="primary"
              :disabled="!agreed"
              :loading="submitting"
              @click="onAgree"
              size="small"
              style="width:80px"
            >
              同意
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SubscriptionTrialAgreementDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      agreed: false,
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },

  watch: {
    visible(val) {
      if (!val) {
        this.agreed = false;
      }
    },
  },

  methods: {
    onClose() {
      if (this.submitting) {
        return;
      }
      this.dialogVisible = false;
      this.agreed = false;
      this.$emit('close');
    },

    onAgree() {
      if (!this.agreed || this.submitting) {
        return;
      }
      this.$emit('agree');
    },
  },
};
</script>

<style scoped>
.popContainer.indiv-pop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
}

.agreement-pop {
  position: relative;
  width: 800px;
  max-width: calc(100vw - 48px);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background: #fff;
}

.agreement-pop .hd {
  position: relative;
  z-index: 1;
  margin: 0;
  padding: 18px 20px;
  font-size: 16px;
  font-weight: 600;
  border-bottom:1px solid #EBEEF5;
  color: #000;
  line-height: 1.4;
}

.agreement-pop .body {
  position: relative;
  z-index: 1;
  padding: 20px 30px 0;
}

.agreement-pop .agreement-content {
  max-height: min(450px, calc(100vh - 280px));
  overflow-y: auto;
  padding: 16px 20px;
  color: #333;
  background: #f9fbff;
  border-radius: 2px;
  font-size: 14px;
  line-height: 1.6;
}

.agreement-pop .agreement-content p {
  margin: 0;
}

.agreement-pop .agreement-warn {
  color: #fb4044;
  text-decoration: underline;
}

.agreement-pop .agreement-check {
  margin-top: 16px;
  
}
.el-checkbox__label{
  font-weight: 500 !important;

}
.agreement-pop .foot {
  position: relative;
  z-index: 1;
  padding: 24px 30px 30px;
  text-align: center;
}

.agreement-pop .foot .indiv-btn.el-button.is-disabled,
.agreement-pop .foot .indiv-btn.el-button.is-disabled:hover,
.agreement-pop .foot .indiv-btn.el-button.is-disabled:focus {
  background-color: #5B85FF !important;
  border-color: #5B85FF !important;
  color: #fff !important;
  opacity: 0.65;
}
</style>



// WEBPACK FOOTER //
// src/view/user/subscriptionService/TrialAgreementDialog.vue